import { Check, AlertCircle } from "lucide-react";

// Mostra sotto a un campo l'esito della validazione: spunta verde se valido,
// messaggio di errore rosso se non valido. Visibile solo quando `show` è true
// (tipicamente dopo la perdita del focus) e il valore non è vuoto.
export function ValidationHint({ result, show, testId = "field" }) {
  if (!show || !result || result.state === "empty") return null;
  if (result.state === "valid") {
    return (
      <div className="mt-1 flex items-center gap-1 text-xs text-emerald-500" data-testid={`${testId}-valid`}>
        <Check className="h-3.5 w-3.5 shrink-0" /> Valido
      </div>
    );
  }
  return (
    <div className="mt-1 flex items-start gap-1 text-xs text-red-500" data-testid={`${testId}-invalid`}>
      <AlertCircle className="h-3.5 w-3.5 shrink-0 mt-0.5" /> <span>{result.error}</span>
    </div>
  );
}
